<template>
  <v-layout row align-center justify-center>
    <v-layout column>
      <v-flex xs8 md8>
        <v-container>
          <v-autocomplete
            :error-messages="errorForField()"
            v-model="taxiStore"
            :items="taxis"
            :loading="loading"
            :search-input.sync="search"
            item-text="registration_number"
            label="Associated Taxi"
            placeholder="Search by registration or plate number"
            hide-no-data
            hide-selected
            no-filter
            return-object
            :disabled="false"
            @input="handleSelected"
          ></v-autocomplete>
        </v-container>
      </v-flex>
      <v-flex xs12 md12>
        <TaxiForm ref="taxiViewForm" :disabled="true" :taxi="taxi" :rideTypes="[]" :councils="[]" />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import TaxiForm from "@/components/driver/TaxiForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "select_taxi",
  components: {
    TaxiForm
  },
  props: {
    taxi: Object,
    errors: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      taxiStore: {},
      loading: false,
      taxis: [],
      search: null
    };
  },
  methods: {
    handleSelected: function() {
      this.$emit("taxiChange", this.taxiStore);
    },
    errorForField: function() {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function() {
      try {
        if (this.errors["use_existing"] != "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {
          console.log(err)
      }
    }
  },
  watch: {
    search(query) {
      console.log(query);
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          self.taxis = res.data.taxis;
          self.loading = false;
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    },
    taxi: function() {
      this.taxiStore = this.taxi;
    }
  }
};
</script>